import React from 'react';
import clsx from 'clsx';

import Container from '@common/Container';
import Section from '@common/Section';
import Img from '@common/Image';
import Row from '@common/Row';
import RichText from '@common/RichText';
import SmallTitle from '@common/SmallTitle';

import Video from '@common/blocks/flex/Video';
import Buttons from '@common/blocks/flex/Buttons';

import { rating } from '@styles/modules/homepage.module.scss';

const StarRating = ({ data }) => {
  const {
    title,
    showTitle,
    text,
    textAlignment,
    listClass,
    showImages,
    imagePosition,
    imagePositionTop,
    imageWidth,
    imageMaxHeight,
    imageNegativeMargin,
    buttons,
    images,
    video,
    topMargin,
    bottomMargin,
    bgColour,
    bgNoPadding,
    bgFullwidth
  } = data;
  return (
    <Section style={{ marginTop: imageNegativeMargin }} spacing={clsx(topMargin, bottomMargin ? bottomMargin : 'mb-7')} className={clsx({
        [`bg-${bgColour}`]: bgColour,
        'py-5': bgColour && !bgNoPadding,
        'container card': !bgFullwidth
      })}>
      <Container>
        {video &&
          <Video data={data}/>
        }
        <Row className={clsx(`d-flex flex-column align-items-center`, {
            'flex-md-row-reverse': imagePosition === 'Left',
            'flex-md-row': imagePosition === 'Right',
            'flex-column-reverse': imagePositionTop,
            'justify-content-center': !images && textAlignment === 'Center'
          })}>
          {(text || buttons) &&
            <div className={clsx('col', {
                'text-center col-lg-10': images && imagePosition === 'Center',
                'text-center': textAlignment === 'Center',
                'text-end': textAlignment === 'Right',
              })}>
              {(showTitle && title) &&
                <SmallTitle>{title}</SmallTitle>
              }
              {text &&
                <RichText
                  json={text}
                  h1='mb-3'
                  h2='mb-3'
                  p='mb-3'
                  li='py-2'
                  a='fs-16'
                  ul={listClass}
                />
              }
              {buttons && 
                <Buttons data={data} />
              }
              {images?.length > 1 && 
                <div className={clsx('d-flex justify-content-lg-start justify-content-center align-items-center mt-3 mb-4 mb-md-0', rating)}>
                  <p className='p-0 m-0 me-2 fs-16'>{images[1].title}</p>
                  <p className='h3 m-0 me-2'>{images[1].description}</p>
                  <div>
                    <Img image={images[1].gatsbyImageData} file={images[1].file}/>
                  </div>
                </div>
              }
            </div>
          }
          {images?.length > 0 &&
            <div style={{ marginTop: `-${imageNegativeMargin}` }} className={clsx('col text-center', imageWidth, {
                [`d-none ${showImages}`]: showImages,
                'mb-3 mb-md-0': imagePositionTop,
                'mt-0': imageNegativeMargin && imagePositionTop,
              })}>
              <Img
                loading='eager'
                image={images[0].gatsbyImageData}
                file={images[0].file}
                alt={images[0].description}
                style={{ maxHeight: imageMaxHeight }}
                imgStyle={{ objectFit: imageMaxHeight ? 'contain' : ''}}
                loop={false}
              />  
            </div>
          }
        </Row>
      </Container>
    </Section>
  )
}

export default StarRating
